// extracted by mini-css-extract-plugin
module.exports = {"vGray2":"#f4f5f7","imageTitle":"PostMainImage_imageTitle__12FEy","slider":"PostMainImage_slider__1xYJn","slide":"PostMainImage_slide__-jUZy"};